<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('schedules')">Schedules</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.source" :error="form.errors.source" class="pr-6 pb-8 w-full lg:w-1/2" label="Source">
            <option v-for="tag in tags" :key="tag" :value="tag">{{ tag }}</option>
          </select-input>
          <select-input v-model="form.frequency" :error="form.errors.frequency" class="pr-6 pb-8 w-full lg:w-1/2" label="Frequency">
            <option v-for="frequency in frequencies" :key="frequency" :value="frequency.toLowerCase()">{{ frequency }}</option>
          </select-input>

          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Email" />
          <select-input v-model="form.format" :error="form.errors.format" class="pr-6 pb-8 w-full lg:w-1/2" label="Format">
            <option v-for="format in formats" :key="format" :value="format.toLowerCase()">{{ format }}</option>
          </select-input>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label" for="input-start-date">Start On</label>
            <date-picker 
              class="w-full"
              input-class="form-input"
              :disabled-date="disabledDate"
              :input-attr="{id:'input-start-date'}"
              v-model="form.start_on" valueType="format">
            </date-picker>
            <div v-if="form.errors.start_on" class="form-error">{{ form.errors.start_on }}</div>
          </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label" for="input-end-date">End On</label>
            <date-picker 
              class="w-full"
              input-class="form-input"
              :disabled-date="disabledDate"
              :input-attr="{id:'input-end-date'}"
              v-model="form.end_on" valueType="format">
            </date-picker>
            <div v-if="form.errors.end_on" class="form-error">{{ form.errors.end_on }}</div>
          </div>          
          <select-input v-model="form.send_at" :error="form.errors.send_at" class="pr-6 pb-8 w-full lg:w-1/2" label="Send At">
            <option v-for="time in times" :key="time" :value="time">{{ time }}</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-blue" type="submit">Create Schedule</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import NProgress from 'nprogress'
import { Inertia } from '@inertiajs/inertia'

import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  metaInfo: { title: 'Create Schedule' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    DatePicker,
  },
  layout: Layout,
  props: {
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        source: null,
        frequency: null,
        email: null,
        format: "csv",
        start_on: null,
        end_on: null,
        send_at: "16:00"
      }),
      tags: null,

      formats: [
        'CSV',
        'Excel'
      ],
      frequencies: [
        'Daily',
        'Every Second Day',
        'Weekly',
        'Every Second Week',
        'Monthly'
      ],

    }
  },
  computed :{
    times() {
      let times = []
      for (let hour = 0; hour < 24; hour++) {
        times.push((hour + "").padStart(2, "0")+":00")
        times.push((hour + "").padStart(2, "0")+":30")
      }
      return times
    }
  },
  async created(){
    let done = false
    Inertia.on('finish', (event) => {
      if(!done){
        NProgress.start()
      }
    })
		const [postrostaConfig, postrostConfig, postrostaV2Config] = await Promise.all([
			axios.get('https://sheets.web-services.verified.eu/postrosta/config'),
      axios.get('https://sheets.web-services.verified.eu/postrost/config'),
      axios.get('https://sheets.web-services.verified.eu/postrosta-v2/config')
		])
    this.tags = [...new Set([...Object.keys(postrostaConfig.data.token), ...Object.keys(postrostConfig.data.token), ...Object.keys(postrostaV2Config.data.token)])]
    done = true
    if(NProgress.isStarted()){
        NProgress.done()
    }
  },
  methods: {
    store() {
      this.form.post(this.route('schedules.store'))
    },
    disabledDate(date, current){
      let today = new Date()      
      return date.setHours(16) < today
    },
  },
}
</script>
